
import { SearchFilters } from '../../../apps/search/schemas'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SearchSummaryBarDetailsPriceRange extends Vue {
  @Prop()
    searchFilters: SearchFilters

  @Prop({ default: true })
    useLink: boolean

  getModifiedSearchFilters(filters: Partial<SearchFilters>) {
    return { ...this.searchFilters, ...filters }
  }

  get ifPriceRange() {
    return this.searchFilters.priceRange
  }

  get minPrice() {
    const price = this.searchFilters?.priceRange?.min || 0
    return {
      amount: price * 100,
      currency: 'GBP',
    }
  }

  get maxPrice() {
    const price = this.searchFilters?.priceRange?.max || 0
    return {
      amount: price * 100,
      currency: 'GBP',
    }
  }

  get hasDates(): boolean {
    const dates = this.searchFilters.dates
    if (!dates || (!dates.arrive && !dates.depart)) return false
    return true
  }
}
